(function () {
  var BOUND = 'ugHkBound';

  function publishGa4(logName, eventName, params) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    Shopify.analytics.publish('ga4Event', {
      log_name: logName,
      event_name: eventName,
      event_parameters: params || {}
    });
  }

  function on(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    return function () {
      target.removeEventListener(type, handler, options);
    };
  }

  function initCountdownFit(root, dispose) {
    root.querySelectorAll('.ug-hackathon-banner .ug-hk-cd-num').forEach(function (el) {
      var fit = function () {
        var wide = (el.textContent || '').trim().length > 2;
        el.classList.toggle('!text-18', !wide);
        el.classList.toggle('lg:!text-28', !wide);
        el.classList.toggle('leading-none', !wide);
        el.classList.toggle('!text-20', wide);
        el.classList.toggle('lg:!text-20', wide);
        el.classList.toggle('!leading-20', wide);
        el.classList.toggle('lg:!leading-20', wide);
      };
      fit();
      var observer = new MutationObserver(fit);
      observer.observe(el, { childList: true, characterData: true, subtree: true });
      dispose(function () { observer.disconnect(); });
    });
  }

  function initNav(root, dispose) {
    var nav = root.querySelector('[data-ug-hackathon-nav]');
    var banner = root.querySelector('[data-ug-hackathon-banner]');
    if (!nav || !banner) return;

    var toggle = nav.querySelector('[data-ug-hackathon-nav-toggle]');
    var menu = nav.querySelector('[data-ug-hackathon-nav-menu]');
    var links = nav.querySelectorAll('[data-ug-hackathon-nav-link]');
    var cta = nav.querySelector('[data-ug-hackathon-nav-cta]');
    var navTitle = nav.getAttribute('data-nav-title') || 'Hackathon';
    var siteHeader = document.querySelector('.section-header');

    var headerOffset = function () {
      if (!siteHeader) return 0;
      var rect = siteHeader.getBoundingClientRect();
      return Math.max(0, Math.min(rect.bottom, rect.height));
    };

    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    var setVisible = function (visible) {
      nav.classList.toggle('is-visible', visible);
      nav.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) nav.removeAttribute('inert');
      else nav.setAttribute('inert', '');
      if (!visible) setOpen(false);
    };

    var updateVisibility = function () {
      nav.style.setProperty('--ug-hk-header-offset', headerOffset() + 'px');
      setVisible(banner.getBoundingClientRect().bottom <= 0);
    };

    var navOffset = function () {
      var bar = nav.firstElementChild;
      return headerOffset() + (bar ? bar.getBoundingClientRect().height : 0);
    };

    var anchorPoint = function (target) {
      // Section IDs live outside the title's responsive top padding.
      // Nested anchors such as the timeline card retain their own position.
      var heading = target.matches('article, section') ? target.querySelector('h2') : null;
      return heading && heading.getClientRects().length ? heading : target;
    };

    var highlight = function () {
      var offset = navOffset() + 8;
      var active = null;
      var activeTop = -Infinity;
      links.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target || !target.getClientRects().length) return;
        var targetTop = anchorPoint(target).getBoundingClientRect().top;
        // Choose the nearest section above the bar, regardless of link order.
        // Allow a pixel for fractional scroll positions after anchor navigation.
        if (targetTop <= offset + 1 && targetTop > activeTop) {
          active = link;
          activeTop = targetTop;
        }
      });
      links.forEach(function (link) {
        var isActive = active ? link.getAttribute('href') === active.getAttribute('href') : false;
        link.classList.toggle('is-active', isActive);
      });
    };

    if (toggle && menu) {
      dispose(on(toggle, 'click', function () {
        setOpen(!nav.classList.contains('is-open'));
      }));
    }

    links.forEach(function (link) {
      dispose(on(link, 'click', function (event) {
        var href = link.getAttribute('href') || '';
        var name = link.getAttribute('data-nav-name') || link.textContent.trim();
        publishGa4('二级导航点击:', 'top_navigation', {
          navigation_name: navTitle + '_' + name
        });
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        setOpen(false);
        window.scrollTo({
          top: anchorPoint(target).getBoundingClientRect().top + window.scrollY - navOffset() - 8,
          behavior: 'smooth'
        });
      }));
    });

    if (cta) {
      dispose(on(cta, 'click', function () {
        publishGa4('按钮点击:', 'click_button', {
          module: 'hackathon',
          button_name: (cta.textContent || '').trim()
        });
      }));
    }

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        if (nav.classList.contains('is-visible')) highlight();
        ticking = false;
      });
    };

    dispose(on(window, 'scroll', onScroll, { passive: true }));
    dispose(on(window, 'resize', onScroll));
    updateVisibility();
    highlight();
  }

  function initCtas(root, dispose) {
    root.querySelectorAll('[data-ug-hackathon-flow-cta], [data-ug-hackathon-cta]').forEach(function (cta) {
      dispose(on(cta, 'click', function () {
        publishGa4('按钮点击:', 'click_button', {
          module: 'hackathon',
          button_name: (cta.textContent || '').trim()
        });
      }));
    });
  }

  function initFaq(root, dispose) {
    root.querySelectorAll('.ug-hk-faq-item').forEach(function (item) {
      var btn = item.querySelector('.ug-hk-faq-q');
      var panel = item.querySelector('.ug-hk-faq-panel');
      if (!btn) return;
      dispose(on(btn, 'click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
          if (open) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
        }
      }));
    });
  }

  function initIntro(root, dispose) {
    var blocks = root.querySelectorAll('[data-ug-hackathon-intro]');
    if (!blocks.length) return;

    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    blocks.forEach(function (block) {
      var body = block.querySelector('.ug-hackathon-intro__body');
      if (body) {
        Array.prototype.forEach.call(body.children, function (child) {
          child.setAttribute('data-reveal-text', '');
        });
      }
      var items = Array.prototype.slice.call(block.querySelectorAll('[data-reveal-text]'));
      if (!items.length || typeof window.IntersectionObserver !== 'function' ||
          (reduceMotion && reduceMotion.matches)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });

      block.classList.add('is-revealing');
      items.forEach(function (item) {
        if (item.getBoundingClientRect().bottom < 0) {
          item.classList.add('is-visible');
        } else {
          observer.observe(item);
        }
      });

      // A large scroll step can skip an observer's intersection window.
      // Reveal every paragraph that has already passed the trigger line.
      var revealPassed = function () {
        var triggerLine = window.innerHeight * 0.75;
        items.forEach(function (item) {
          if (item.classList.contains('is-visible') || item.getBoundingClientRect().top > triggerLine) return;
          item.classList.add('is-visible');
          observer.unobserve(item);
        });
      };
      dispose(on(window, 'scroll', revealPassed, { passive: true }));
      dispose(on(window, 'resize', revealPassed));

      var showAll = function () {
        observer.disconnect();
        block.classList.remove('is-revealing');
        items.forEach(function (item) { item.classList.add('is-visible'); });
      };

      dispose(on(block, 'focusin', function (event) {
        var item = event.target.closest && event.target.closest('[data-reveal-text]');
        if (!item || !block.contains(item)) return;
        item.classList.add('is-visible');
        observer.unobserve(item);
      }));

      if (window.Shopify && window.Shopify.designMode) {
        dispose(on(document, 'shopify:block:select', function (event) {
          if (event.target === block) showAll();
        }));
      }

      if (reduceMotion) {
        var onMotionChange = function () {
          if (reduceMotion.matches) showAll();
        };
        if (typeof reduceMotion.addEventListener === 'function') {
          dispose(on(reduceMotion, 'change', onMotionChange));
        } else if (typeof reduceMotion.addListener === 'function') {
          reduceMotion.addListener(onMotionChange);
          dispose(function () { reduceMotion.removeListener(onMotionChange); });
        }
      }

      dispose(function () {
        observer.disconnect();
        block.classList.remove('is-revealing');
        items.forEach(function (item) { item.classList.remove('is-visible'); });
      });
    });
  }

  function initCarousel(block, opts, dispose) {
    var viewport = block.querySelector(opts.viewport);
    var slides = Array.prototype.slice.call(block.querySelectorAll(opts.slide));
    var dotsWrap = block.querySelector(opts.dots);
    var prev = block.querySelector(opts.prev);
    var next = block.querySelector(opts.next);
    if (!viewport || !slides.length || !dotsWrap) return;

    var index = 0;
    var autoTimer = null;
    var scrollLock = 0;
    var inView = false;
    var desktopMq = window.matchMedia('(min-width: 1024px)');
    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

    var isDesktop = function () {
      return desktopMq.matches;
    };

    var syncUi = function () {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.classList.toggle('w-30', active);
        dot.classList.toggle('w-5', !active);
        dot.classList.toggle('opacity-100', active);
        dot.classList.toggle('opacity-50', !active);
      });
      if (prev) {
        prev.classList.toggle('cursor-default', index === 0);
        prev.classList.toggle('opacity-[0.33]', index === 0);
      }
      if (next) {
        var atEnd = index === slides.length - 1 && !opts.loopNext;
        next.classList.toggle('cursor-default', atEnd);
        next.classList.toggle('opacity-[0.33]', atEnd);
      }
    };

    var stopAuto = function () {
      if (autoTimer) {
        window.clearTimeout(autoTimer);
        autoTimer = null;
      }
      dots.forEach(function (dot) {
        var fill = dot.querySelector('.' + opts.fillClass);
        if (!fill) return;
        fill.style.animation = 'none';
        fill.style.transform = 'scaleX(0)';
      });
    };

    var restartAuto = function () {
      stopAuto();
      if (!inView || isDesktop() || reduceMq.matches || slides.length < 2) return;
      var active = dots[index];
      var fill = active && active.querySelector('.' + opts.fillClass);
      if (fill) {
        fill.style.animation = 'none';
        fill.style.transform = 'scaleX(0)';
        void fill.offsetWidth;
        fill.style.transform = '';
        fill.style.animation = opts.progressAnim + ' 4s linear forwards';
      }
      autoTimer = window.setTimeout(function () {
        goTo(index + 1 >= slides.length ? 0 : index + 1, false);
      }, 4000);
    };

    var goTo = function (nextIndex, instant) {
      scrollLock = Date.now() + 500;
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      var slide = slides[index];
      viewport.scrollTo({
        left: slide.offsetLeft - viewport.offsetLeft,
        behavior: instant || reduceMq.matches ? 'auto' : 'smooth'
      });
      syncUi();
      restartAuto();
    };

    if (!dotsWrap.querySelector('.' + opts.dotClass)) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = opts.dotClass + ' relative block h-5 w-5 cursor-pointer overflow-hidden rounded-full border-0 bg-[#a3a3a3] p-0 opacity-50';
        dot.setAttribute('aria-label', opts.labelPrefix + ' ' + (i + 1));
        var fill = document.createElement('span');
        fill.className = opts.fillClass + ' absolute inset-0 hidden origin-left rounded-full bg-black';
        fill.setAttribute('aria-hidden', 'true');
        dot.appendChild(fill);
        dotsWrap.appendChild(dot);
      });
    }

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.' + opts.dotClass));
    dots.forEach(function (dot, i) {
      dispose(on(dot, 'click', function () {
        goTo(i, false);
      }));
    });

    var onScroll = function () {
      if (isDesktop() || Date.now() < scrollLock) return;
      var nearest = 0;
      var best = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - viewport.offsetLeft - viewport.scrollLeft);
        if (dist < best) {
          best = dist;
          nearest = i;
        }
      });
      if (nearest !== index) {
        index = nearest;
        syncUi();
        restartAuto();
      }
    };

    var onResize = function () {
      if (isDesktop()) {
        stopAuto();
        viewport.scrollLeft = 0;
        index = 0;
        syncUi();
        return;
      }
      goTo(index, true);
    };

    if (prev) {
      dispose(on(prev, 'click', function () {
        if (index > 0) goTo(index - 1, false);
      }));
    }
    if (next) {
      dispose(on(next, 'click', function () {
        if (index < slides.length - 1) goTo(index + 1, false);
        else if (opts.loopNext) goTo(0, false);
      }));
    }

    dispose(on(viewport, 'scroll', onScroll, { passive: true }));
    dispose(on(window, 'resize', onResize));
    dispose(on(block, 'mouseenter', stopAuto));
    dispose(on(block, 'mouseleave', restartAuto));
    dispose(on(block, 'touchstart', stopAuto, { passive: true }));
    dispose(on(block, 'touchend', restartAuto, { passive: true }));
    dispose(stopAuto);

    syncUi();

    if ('IntersectionObserver' in window) {
      var viewObserver = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (entry) { return entry.isIntersecting; });
        if (visible === inView) return;
        inView = visible;
        if (visible) restartAuto();
        else stopAuto();
      }, { threshold: 0.6 });
      viewObserver.observe(viewport);
      dispose(function () { viewObserver.disconnect(); });
    } else {
      inView = !isDesktop();
      restartAuto();
    }
  }

  function initCarousels(root, dispose) {
    root.querySelectorAll('[data-ug-hackathon-prizes]').forEach(function (block) {
      initCarousel(block, {
        viewport: '[data-prizes-viewport]',
        slide: '[data-prizes-slide]',
        dots: '[data-prizes-dots]',
        prev: '[data-prizes-prev]',
        next: '[data-prizes-next]',
        dotClass: 'ug-hk-prizes-dot',
        fillClass: 'ug-hk-prizes-dot-fill',
        labelPrefix: 'Prize',
        loopNext: true,
        progressAnim: 'ug-hk-prize-progress'
      }, dispose);
    });

    root.querySelectorAll('[data-ug-hackathon-criteria]').forEach(function (block) {
      initCarousel(block, {
        viewport: '[data-criteria-viewport]',
        slide: '[data-criteria-slide]',
        dots: '[data-criteria-dots]',
        prev: '[data-criteria-prev]',
        next: '[data-criteria-next]',
        dotClass: 'ug-hk-criteria-dot',
        fillClass: 'ug-hk-criteria-dot-fill',
        labelPrefix: 'Criterion',
        loopNext: true,
        progressAnim: 'ug-hk-criteria-progress'
      }, dispose);
    });
  }

  function initTracks(root, dispose) {
    root.querySelectorAll('[data-ug-hackathon-tracks]').forEach(function (block) {
      var dialog = block.querySelector('[data-track-dialog]');
      var content = block.querySelector('[data-track-dialog-content]');
      if (!dialog || !content) return;
      var panel = dialog.querySelector('[role="dialog"]');
      var lastFocus = null;
      var previousOverflow = '';

      var close = function () {
        if (dialog.hidden) return;
        dialog.hidden = true;
        document.body.style.overflow = previousOverflow;
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      var open = function (source, trigger) {
        if (!source) return;
        lastFocus = trigger || document.activeElement;
        content.innerHTML = source.innerHTML;
        var title = content.querySelector('h3');
        if (title && panel) {
          title.id = source.id + '-heading';
          panel.setAttribute('aria-labelledby', title.id);
        }
        dialog.hidden = false;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        var closeBtn = dialog.querySelector('button[data-track-close]');
        if (closeBtn) closeBtn.focus();
      };

      dispose(on(dialog, 'keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }));

      block.querySelectorAll('[data-track-open]').forEach(function (btn) {
        dispose(on(btn, 'click', function () {
          var id = btn.getAttribute('data-track-target');
          open(id ? document.getElementById(id) : null, btn);
        }));
      });

      dialog.querySelectorAll('[data-track-close]').forEach(function (el) {
        dispose(on(el, 'click', close));
      });

      dispose(on(document, 'keydown', function (event) {
        if (event.key === 'Escape' && !dialog.hidden) close();
      }));
      dispose(function () {
        if (!dialog.hidden) close();
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset[BOUND] === '1') return;
    root.dataset[BOUND] = '1';

    var cleanups = [];
    var dispose = function (fn) { cleanups.push(fn); };

    initCountdownFit(root, dispose);
    initNav(root, dispose);
    initCtas(root, dispose);
    initFaq(root, dispose);
    initIntro(root, dispose);
    initCarousels(root, dispose);
    initTracks(root, dispose);

    root._ugHkCleanup = function () {
      cleanups.forEach(function (fn) { fn(); });
      cleanups = [];
      delete root.dataset[BOUND];
    };
  }

  function findRoot(node) {
    if (!node || !node.querySelector) return null;
    if (node.classList && node.classList.contains('ug-hackathon')) return node;
    return node.querySelector('.ug-hackathon');
  }

  function boot() {
    document.querySelectorAll('.ug-hackathon').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRoot(event.target);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRoot(event.target);
    if (root && typeof root._ugHkCleanup === 'function') root._ugHkCleanup();
  });
})();
